



























import moment from 'moment';
import VideoPlayer from '@getaccept/lib-shared/src/video/player/components/VideoPlayer.vue';
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import PlayIcon from '../assets/play.svg';
import { MomentLocaleHelper } from '../../helpers/moment-locale-helper';

export default defineComponent({
  components: {
    VideoPlayer,
    PlayIcon,
  },
  props: {
    name: { type: String, default: '' },
    expirationDate: { type: String, default: '' },
    videoThumbnail: { type: String, default: '' },
    videoUrl: { type: String, default: '' },
    reminderExpirationDays: { type: Number, default: undefined },
    isSigned: { type: Boolean },
    signDate: { type: String, default: '' },
    showExpiration: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    moment.locale(MomentLocaleHelper.getLocale());
    const time = ref(moment().utc());
    const intervalTimer = ref(null);

    const watchIsSigned = () => {
      time.value = moment().utc();
    };
    watch(() => props.isSigned, watchIsSigned);

    const documentStatusInformationText = computed((): string =>
      props.isSigned ? signedText.value : expirationText.value
    );

    const signedText = computed((): string => {
      const timeAgo: string = moment.utc(props.signDate).from(time.value);
      return `${t('signed')} ${timeAgo}`;
    });

    const expirationText = computed((): string => {
      const timeTo: string = moment.utc(props.expirationDate).from(time.value);
      const expired: boolean = moment.utc(props.expirationDate).diff(time.value) < 0;
      return expired ? `${t('expired')} ${timeTo}` : `${t('expires')} ${timeTo}`;
    });

    const expirationWarning = computed((): boolean => {
      if (props.isSigned) {
        return false;
      }
      const diff: number = moment.utc(props.expirationDate).diff(time.value, 'days');

      return diff < props.reminderExpirationDays;
    });

    const handleClick = () => {
      emit('videoIntro');
    };

    onMounted(() => {
      intervalTimer.value = setInterval(() => {
        time.value = moment().utc();
      }, 60000);
    });

    onBeforeUnmount(() => {
      clearInterval(intervalTimer.value);
    });

    return {
      time,
      intervalTimer,
      documentStatusInformationText,
      signedText,
      expirationText,
      expirationWarning,
      handleClick,
    };
  },
});
